/**
 * Threshold Achievement Report settings schema.
 *
 * Introduces the `number` field type: the pass threshold, a percentage a point
 * must stay in range for to "pass". It is a manual-run setting (it applies to
 * both on-demand and template runs), so it renders in the Report Settings drawer
 * on a manual run as well. The report has a fixed monthly schedule, so there is
 * no Scheduled Delivery section. Setting keys (`passThreshold`) are unchanged
 * from the pre-schema ThresholdAchievementReportSettings.vue.
 */
export default {
    slug: 'threshold-achievement-report',
    icon:
        '<path stroke="none" d="M0 0h24v24H0z" fill="none"/>'
        + '<path d="M8 21l8 0" />'
        + '<path d="M12 17l0 4" />'
        + '<path d="M7 4l10 0" />'
        + '<path d="M17 4v8a5 5 0 0 1 -10 0v-8" />'
        + '<path d="M3 9a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />'
        + '<path d="M17 9a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />',
    permission: 'manage_compliance_achievement_report',
    title: 'Threshold Achievement',
    description: 'How often each point stayed within its limits, and which ones fell below your pass threshold.',
    info: 'For every point you can see, the percent of readings that stayed within its high and low alarm limits over the period, marked Pass or Fail against your target. Points with no readings show as Offline and fail.',

    sections: [
        {
            title: 'Pass Threshold (%)',
            description: 'Set the bar a point must clear to be counted as passing.',
            fields: [
                {
                    key: 'passThreshold',
                    type: 'number',
                    label: 'Pass threshold (%)',
                    description: 'A point passes when more than this percent of its readings fall within its alarm limits. At 95, a point needs over 95% of readings in range; exactly 95% fails.',
                    min: 0,
                    max: 100,
                    step: 1,
                },
            ],
        },
    ],
}
